<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="chapter"></HeaderComp>

        <KenyaChapterContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import KenyaChapterContent from '@/views/content/chapters/KenyaChapterContent'
export default {
  components: { KenyaChapterContent, FooterComp, HeaderComp },

  data() {
    return {}
  },
}
</script>
